import * as React from 'react';
import './ColorBall.scss';
import { ChromePicker } from 'react-color';
import { Menu, MenuItem } from '@material-ui/core';
import { useTranslations } from '../../store/translations/hooks';
import { TK } from '../../store/translations/translationKeys';

export interface ColorBallProps {
    id?: string,
    color?: string,
    children?: React.ReactNode | string,
    onClick?: () => void,
    onChange?: (color: string | undefined) => void,
    style?: React.CSSProperties,
    size?: 'xs' | 'default',
}

const ColorBall : React.FC<ColorBallProps> = ({id, color = '#AAAAAA', children, style, size, onClick, onChange}) => {
    const [editing, setEditing] = React.useState(false)
    const [contextMenu, setContextMenu] = React.useState<{ mouseX: number; mouseY: number } | null>(null)

    const t = useTranslations()

    const handleClick = () => {
        onClick && onClick()
        onChange && setEditing(prev => !prev)
    }

    const handleContextMenu = (e: React.MouseEvent) => {
        if (onChange) {
            e.preventDefault()
            setContextMenu({ mouseX: e.clientX, mouseY: e.clientY })
        }
    }

    const handleClearColor = () => {
        if (onChange) {
            onChange(undefined)
        }
        setContextMenu(null)
    }

    const handleCloseContextMenu = () => {
        setContextMenu(null)
    }

    const className = size === 'xs' ? 'colorBalXs' : 'colorBal';

    return <>
        {children
            ? (<div id={id} onClick={handleClick} onContextMenu={handleContextMenu} style={style} className="colorBalContainer"><div style={{backgroundColor: color}} className={className}/>{children}</div>)
            : (<div id={id} onClick={handleClick} onContextMenu={handleContextMenu} style={{...style, backgroundColor: color}} className={className}/>)}
        {onChange && editing && <ChromePicker
            color={color}
            onChange={color => onChange(color.hex)}
        />}
        <Menu
            open={contextMenu !== null}
            onClose={handleCloseContextMenu}
            anchorReference="anchorPosition"
            anchorPosition={
                contextMenu !== null
                    ? { top: contextMenu.mouseY, left: contextMenu.mouseX }
                    : undefined
            }
        >
            <MenuItem onClick={handleClearColor}>{t(TK.clear)}</MenuItem>
        </Menu>
    </>

}

export default ColorBall;